import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext({
  theme: 'dark',
  toggleTheme: () => {},
  cursorEffect: true,
  toggleCursorEffect: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('theme') || 'dark';
    }
    return 'dark';
  });
  
  const [cursorEffect, setCursorEffect] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('cursorEffect') !== 'false';
    }
    return true;
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem('cursorEffect', cursorEffect.toString());
  }, [cursorEffect]);

  const toggleTheme = useCallback(() => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  }, []);

  const toggleCursorEffect = useCallback(() => {
    setCursorEffect(prev => !prev);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, cursorEffect, toggleCursorEffect }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
